/* Pop-up de pesquisa Navita (fase 7b): as "pesquisas frequentes" pesquisam dentro do pop-up em vez de abrirem a página
   de resultados. Sem este ficheiro, os mesmos botões continuam a funcionar como links para /search?q=… */
if (!window.navitaPesquisaPronto) {
  window.navitaPesquisaPronto = true;
  document.addEventListener('click', (e) => {
    const chip = e.target.closest('.npq [data-npq-termo]');
    if (!chip) return;
    const campo = chip.closest('predictive-search-component')?.querySelector('input[type="search"]');
    if (!campo) return;
    e.preventDefault();
    campo.value = chip.dataset.npqTermo;
    // o componente do tema só pesquisa com eventos de escrita (inputType)
    campo.dispatchEvent(new InputEvent('input', { bubbles: true, inputType: 'insertText', data: campo.value }));
    campo.focus();
  });
}
